import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { colors, fonts, radii } from "../designTokens";
import useIsMobile from "../hooks/useIsMobile";

// Mobile-only shortcut back to the upload/record section, so users don't have
// to scroll all the way back up on the long homepage. Mirrors the Hero CTA's
// styling (not the big yellow record button itself) — it's a way back to the
// main action, not a second version of it.
export default function UploadFab() {
  const { t } = useTranslation();
  const isMobile = useIsMobile();
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    if (!isMobile) return;

    let cleanupSetup = null;
    const setup = (section) => {
      const heroEl = document.querySelector(".hero-cta-btn");

      const onScroll = () => {
        const pastHero = !heroEl || heroEl.getBoundingClientRect().bottom < 0;
        setVisible(pastHero);
      };

      const observer = new IntersectionObserver(
        ([entry]) => {
          if (entry.isIntersecting) setVisible(false);
          else onScroll();
        },
        { rootMargin: "0px 0px -40% 0px" }
      );
      observer.observe(section);

      window.addEventListener("scroll", onScroll, { passive: true });
      onScroll();

      return () => {
        observer.disconnect();
        window.removeEventListener("scroll", onScroll);
      };
    };

    const existing = document.getElementById("fart-upload-section");
    if (existing) {
      cleanupSetup = setup(existing);
      return () => cleanupSetup && cleanupSetup();
    }

    // FartUpload ist lazy geladen: beim ersten Besuch existiert die Section beim
    // Mount noch nicht. Warten, bis sie im DOM auftaucht (sonst erschien der FAB nie).
    const mo = new MutationObserver(() => {
      const section = document.getElementById("fart-upload-section");
      if (section) {
        mo.disconnect();
        cleanupSetup = setup(section);
      }
    });
    mo.observe(document.body, { childList: true, subtree: true });

    return () => {
      mo.disconnect();
      if (cleanupSetup) cleanupSetup();
    };
  }, [isMobile]);

  if (!isMobile || !visible) return null;

  return (
    <button
      type="button"
      onClick={() => {
        document.getElementById("fart-upload-section")?.scrollIntoView({ behavior: "smooth" });
      }}
      aria-label={t("fab.uploadShortcut")}
      style={{
        position: "fixed",
        bottom: 24,
        left: 16,
        zIndex: 998,
        background: colors.ctaGradient,
        border: "none",
        borderRadius: radii.pill,
        padding: "10px 16px",
        display: "inline-flex",
        alignItems: "center",
        gap: 6,
        fontFamily: fonts.body,
        fontWeight: 800,
        fontSize: 13,
        color: colors.greenDark,
        boxShadow: "0 4px 18px rgba(0,0,0,0.22)",
        cursor: "pointer",
      }}
    >
      🎙️ {t("fab.uploadShortcut")}
    </button>
  );
}
